import { put } from 'common/api';

export const updateTerms = async id => {
  try {
    await put(`/users/${id}/accept_tos`);
  } catch (err) {
    return err.errors.message;
  }
};
